export const formatPrice = (price) => {
    if (price === null || price === undefined) return '0.00';
    return Number(price).toFixed();
};

// Helper function to format currency with PKR
export const formatCurrency = (price) => {
    return `PKR ${formatPrice(price)}`;
};

// Helper function to format currency without .00 for whole numbers
export const formatCurrencyClean = (price) => {
    if (price === null || price === undefined) return 'PKR 0';
    const num = Number(price);
    if (num % 1 === 0) {
        return `PKR ${num.toLocaleString()}`;
    }
    return `PKR ${num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};





/*export const formatCurrency = (amount) => {
    if (amount === null || amount === undefined) return 'N/A';
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(amount);
};*/



/**
 * Converts a string to title case (capitalizes first letter of each word)
 * @param {string} str - The string to convert
 * @returns {string} - The string in title case, or 'N/A' if input is null/undefined/empty
 */
export const toTitleCase = (str) => {
    if (!str || str === null || str === undefined) return 'N/A';
    return str.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
}; 